<template>
  <div class="index">
    <template v-if="!['/'].includes($route.path)">
      <div v-if="$route.meta.isHide == 2" class="head-munu">
        <Tab></Tab>
      </div>
      <div v-else class="index-header">
        <div class="header_logo">
          <template>
            <div @click="goTo" class="img_logo">
              <img src="../assets/info/logo1.png" class="logo1" alt="" />
              <div>金骊保电子保函平台</div>
            </div>
            <div class="logo_right">
              <div class="info">客服电话</div>
              <div class="phone">
                <div>18676717124/18576680731</div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import Tab from "./Tab/index.vue";
export default {
  components: { Tab },
  data() {
    return {};
  },
  mounted() {
    console.log(this.$route.path);
  },
  methods: {
    goTo() {
      this.$router.push({ path: "/" });
    },
  },
};
</script>
<style lang="less" scoped>
.index {
  
}
.header {
  justify-content: flex-start !important;
}
.index-header {
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  // padding: 0 140px;
  .head-welcome {
    color: #999999;
    min-width: 200px;
  }
  .header_logo {
    width: 1200px;
    padding: 5px 0;
    margin: 0!important;
    display: flex;
    justify-content: space-between;
    line-height: 40px;
    font-weight: bold;
    font-size: 20px;
    color: #333333;
    .img_logo {
      margin-right: 226px;
        display: flex;
        margin-top: 8px;
        line-height: 36px;
        img {
          width: 36px;
          height: 36px;
          margin-right: 8px;
        }
    }
    .logo_right {
      display: flex;
    }
    .info {
      height: 100%;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      padding-top: 3px;
      margin-right: 10px;
      line-height: 50px;
    }
    .phone {
      font-size: 24px;
      font-family: DIN Medium-Regular, DIN Medium;
      font-weight: 400;
      color: #0E52D4;
      line-height: 52px;
    }
  }
}
.head-munu {
}
::v-deep .ant-menu-horizontal {
  border-bottom: none !important;
  font-size: 18px;
}
::v-deep .ant-menu-item,
.ant-menu-submenu-title {
  font-size: 18px;
}
::v-deep .ant-menu-horizontal > .ant-menu-item,
.ant-menu-horizontal > .ant-menu-submenu {
  top: 0px !important;
  border-bottom: none !important;
}
::v-deep .ant-menu-submenu-selected,
.ant-menu-horizontal > .ant-menu-item-selected > a {
  color: #2e4e9a !important;
  font-weight: 600;
}
::v-deep .ant-menu-submenu-title:hover,
.ant-menu-item-active > a,
.ant-menu-submenu-open .ant-menu-submenu-title .submenu-title-wrapper {
  color: #2e4e9a !important;
}

</style>
